"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _noop2 = _interopRequireDefault(require("lodash-es/noop"));

var _popover = _interopRequireDefault(require("../../atoms/popover"));

var _icon = _interopRequireDefault(require("../../atoms/icon"));

var _fontIcon = _interopRequireWildcard(require("../../atoms/font-icon"));

var _tokens = require("../../../tokens");

var _utilities = require("../../_utils/utilities");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  font-weight: ", ";\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  width: 100%;\n  max-height: 400px;\n  overflow-y: auto;\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ", ", " {\n    cursor: pointer;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var IconWrapper = _styledComponents["default"].span(_templateObject(), _icon["default"].Element, _fontIcon.StyledIcon);

var StyledContent = _styledComponents["default"].span(_templateObject2(), _tokens.fonts.weight.normal);

var IconPopover =
/*#__PURE__*/
function (_React$Component) {
  _inherits(IconPopover, _React$Component);

  function IconPopover(props) {
    var _this;

    _classCallCheck(this, IconPopover);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconPopover).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "toggleOpen", function () {
      _this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      }, function () {
        return _this.handleOpenClose(_this.state.isOpen);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChildSelection", function () {
      if (!_this.props.closeOnContentClick) return;

      _this.toggleOpen();
    });

    _defineProperty(_assertThisInitialized(_this), "handleOpenClose", function (open) {
      if (open) {
        _this.props.onOpen();
      } else {
        _this.props.onClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getIcon", function () {
      if (_utilities.iconPattern.test(_this.props.icon)) {
        return _react["default"].createElement(IconWrapper, {
          onClick: _this.toggleOpen
        }, _react["default"].createElement(_fontIcon["default"], {
          size: _this.props.size
        }, _this.props.icon));
      }

      return _react["default"].createElement(IconWrapper, {
        onClick: _this.toggleOpen
      }, _react["default"].createElement(_icon["default"], {
        size: _this.props.size,
        name: _this.props.icon
      }));
    });

    _this.state = {
      isOpen: props.open
    };
    return _this;
  }

  _createClass(IconPopover, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = _react["default"].cloneElement(this.props.children, {
        onChildSelection: this.onChildSelection
      });

      var content = _react["default"].createElement(StyledContent, _extends({
        tabIndex: '0',
        innerRef: function innerRef(e) {
          return _this2.styledContent = e;
        }
      }, this.props), children);

      return _react["default"].createElement(_popover["default"], {
        open: this.state.isOpen,
        onClose: this.toggleOpen,
        content: content,
        align: this.props.align,
        position: this.props.position,
        pointed: this.props.pointed,
        icon: this.props.icon,
        adjustVerticalAlign: false,
        contentDisabled: this.props.disabled
      }, this.getIcon());
    }
  }]);

  return IconPopover;
}(_react["default"].Component);

IconPopover.propTypes = {
  open: _propTypes["default"].bool,
  align: _propTypes["default"].oneOf(['left', 'middle', 'right', 'top', 'bottom']),

  /** disabled flag */
  disabled: _propTypes["default"].bool,

  /** icon name */
  icon: _propTypes["default"].string,

  /** icon size */
  size: _propTypes["default"].number,

  /** Where to place the popover */
  position: _propTypes["default"].oneOf(['top', 'bottom', 'left', 'right']),

  /** show pointed arrow */
  pointed: _propTypes["default"].bool,

  /** popover closes on clicking inside */
  closeOnContentClick: _propTypes["default"].bool
};
IconPopover.defaultProps = {
  open: false,
  align: 'middle',
  disabled: false,
  icon: 'info',
  pointed: true,
  size: 14,
  position: 'bottom',
  onClose: _noop2["default"],
  onOpen: _noop2["default"],
  closeOnContentClick: true
};
var _default = IconPopover;
exports["default"] = _default;